<template>
<div class="">
  <div class="columns is-centered">
    <div class="column is-half ">
        <table class="table is-narrow is-fullwidth is-bordered is-striped">
          <thead>
            <th class="has-text-centered" width="150px">Bezeichnung</th>
            <th class="has-text-centered" width="150px">Artikelnr.</th>
            <th class="has-text-centered" width="150px">Menge</th>
            <th></th>
          </thead>
          <tbody>
            <tr v-for="(lineItem, index) in cart" :key="index">
              <td class="has-text-centered">{{ lineItem.name }}</td>
              <td class="has-text-centered">{{ lineItem.sku }}</td>
              <td align="center">
                <QuantitySelect
                  size="is-small"
                  :variation-id="lineItem.id"
                  :pre-selected-quantity="lineItem.quantity"
                  @setQuantity="setQuantity"
                />
                </td>
              <td class="has-text-centered" width="50px"><div class="delete" @click="removeLineItem(lineItem)" /></td>
            </tr>
          </tbody>
        </table>
        <div class="columns" v-if="this.cart.length === 0">
          <div class="column has-text-centered">
            <p>es sind keine Produkte in der Liste vorhanden</p>
          </div>
        </div>
        <div class="columns" v-if="this.cart.length === 0">
          <div class="column has-text-centered">
            <button class="is-size-5" @click="restartConfigurator">	&#129144; Konfiguration neustarten</button>
          </div>
        </div>
        <div class="columns">
          <div class="column has-text-centered">
            <button :disabled="cart.length === 0" class="button is-primary" @click="orderModalOpen = true"><span class="item-count">{{ cart.length }}</span>Auftragsanfrage</button>
            <OrderModal v-if="orderModalOpen" @close="orderModalOpen = false" />
          </div>
        </div>
      </div>
  </div>
    <div class="content is-normal">
      <h2>Bestellung</h2>
        <p><strong>Sie können uns telefonisch unter 0681 - 58601 - 0, per Telefax unter 0681 - 58601 - 39, oder der Durchwahl eines unserer Mitarbeiter erreichen.</strong></p>
          <ul>
            <li>Bitte geben Sie bei Ihren Bestellungen, sofern vorhanden, immer Ihre Kundennummer an.</li>
            <li>Benutzen Sie bitte bei Bestellungen unsere Produktbezeichnung. Dadurch werden Fehler bei der Übernahme weitgehend ausgeschlossen, es erleichtert unsere Arbeit, und Ihre Bestellungen gelangen schneller zur Auslieferung.</li>
          </ul>
      <h2>Versand</h2>
        <p>Wir liefern auf dem schnellsten Wege – in der Regel am gleichen Tag – per Paketdienst, Spedition oder Express-Dienst. Nicht immer werden wir Lieferzeiten vermeiden können. In solchen Fällen können wir Ihren Auftrag auch in Teilmengen sofort ausliefern.</p>
      <h2>Express-Service</h2>
        <p>Wenn es einmal ganz eilig ist: Auf Wunsch versenden wir Ihre Aufträge nach Absprache per Terminexpress oder Kurierservice mit garantierter Zustellung am nächsten Arbeitstag.</p>
        <p>Mehrkosten entstehen Ihnen lediglich in Höhe der Transportkosten für den Express-Dienst.</p>
      <h2>Preise</h2>
        <p>Für Fehler bei den Preisangaben übernehmen wir keine Haftung. Alle angegebenen Preise verstehen sich ohne Mehrwertsteuer.</p>
      <h2>Versandkosten</h2>
        <div class="columns delivery-informations">
          <div class="column is-2">
            <p class="delivery-title">Innerhalb Deutschlands</p>
            <p>Warenwert unter 300,00€:</p>
            <p>Warenwert ab 300,00€:</p>
            <br>
            <p class="delivery-title">Auslandslieferungen</p>
            <p>Warenwert unter 2.500,00€:</p>
            <p>Warenwert ab 2.500,00€:</p>
          </div>
          <div class="column is-2 delivery-informations-2">
            <br>
            <br>
            <p>9,50€</p>
            <p>Frachfrei</p>
            <br>
            <br>
            <br>
            <p>ab Werk Saarbrücken (EXW)</p>
            <p>frei Haus (CPT)</p>
          </div>
        </div>
      <h2>Warenrücknahme</h2>
        <p>Wir nehmen Ware grundsätzlich nur nach vorheriger Absprache und unter Abzug von 20% Bearbeitungsgebühr (mindestens jedoch € 10,00) zurück. Die Kosten der Rücksendung gehen zu Ihren Lasten.</p>
      <h2>Mängel</h2>
        <p>Offensichtliche Mängel sollten Sie uns sofort, spätestens jedoch innerhalb von 14 Tagen nach der Lieferung melden. Wir werden die Mängel beheben oder Ihnen Ersatz liefern.</p>
    </div>
  </div>
</template>

<script>
import QuantitySelect from '@/components/QuantitySelect'
import { createToast } from 'mosha-vue-toastify';
import 'mosha-vue-toastify/dist/style.css'
import OrderModal from '@/components/modals/OrderModal'
export default { 
  components: { QuantitySelect, OrderModal },
  data () {
        return {
            orderModalOpen: false
        }
    },
    setup () {
      const toast2 = () => {    
      createToast('Produkt entfernt',
          {
          type: 'danger',
          timeout: 1500,
          showIcon: true,
          transition: 'bounce',
          position: 'top-center',
          
          })
      }
  return { toast2 }
  },
  computed: {
    cart () {
      return this.$store.state.cart
    },
    currentProduct: {
      set (val) {
          this.$store.commit('setCurrentProduct', val)
      },
      get () {
          return this.$store.state.currentProduct
      }
    },
    totalPrice () {
      return this.$store.getters.totalPrice
    },
    currentStep: {
      set (val) {
          this.$store.commit('setCurrentStep', val)
      },
      get () {
          return this.$store.state.currentStep
      }
    }
  },
  methods: {
    setQuantity (val) {
      this.$store.commit('updateQuantityInCart', val)
    },
    removeFromCart (lineItem) {
      this.$store.commit('removeFromCart', lineItem)
    },
    removeLineItem (lineItem) {
      this.removeFromCart(lineItem)
      this.toast2()
    },
    restartConfigurator () {
     if (this.cart.length === 0) {
        this.currentProduct = null
        this.currentStep = 'Unterkonstruktion'
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.modal-card-body
  height: 80vh
  .preview-wrap
    height: 300px
  .input, .textarea
    border-color: grey

.delete
  vertical-align: middle

.item-count
    border-radius: 50%
    display: grid
    place-items: center
    width: 30px
    height: 30px
    background: white
    color: black
    margin-right: 10px

.delivery-informations
  line-height: 1rem

.delivery-title
  text-decoration: underline
</style>